import { CartesianGrid, Legend, Area, AreaChart, Tooltip, XAxis, YAxis } from "recharts"

import { CustomizedAxisTickInTwoLines, CustomTooltipWithFilterInfo } from "@/components/Analytics/analyticsChartCustomize"

import { AnalyticsChartProps, diagramColors } from "@/types/IAnalytics"

import { compactNumber } from "@/utils/formatNumber"


export const AnalyticsAreaChart = (props: AnalyticsChartProps) => {
  const { data, dataKeys, colors, filtersText } = props

  return (
    <AreaChart width={1400} height={600} data={data}
      margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
      <XAxis dataKey="period" tick={CustomizedAxisTickInTwoLines} />
      <YAxis domain={["auto", "auto"]} tickFormatter={compactNumber} />
      <Tooltip content={(props) => (<CustomTooltipWithFilterInfo {...props} filtersText={filtersText} />)} />
      <Legend wrapperStyle={{ width: "100%" }} />
      <CartesianGrid stroke="#f5f5f5" />
      {
        dataKeys.map((data, index) => (
          <Area
            dot={false}
            key={index}
            type="monotone"
            dataKey={data.value}
            name={`${data.bigLabel}${data.optionsLabel ? `: ${data.optionsLabel}` : ""}`}
            stroke={(colors ?? diagramColors)[index]}
            fill={(colors ?? diagramColors)[index]} />
        ))
      }
    </AreaChart>
  )
}
